import { Deck, DeckCard, DeckCardTagType } from "@apiserver-rest/ponder-data-client-base";
import { DeckGroup } from "@ponder-features/user/decks/deck/group/deck-group";
import { environment } from "../../../../../environments/environment";

export class MagicDeckGroupCommander extends DeckGroup {
    public constructor() {
        super("Commander", `${environment.ponderImageBaseUrl}/magic/set/ktk.svg`);
    }
    
    public override isValid(deck: Deck, card: DeckCard): boolean {
        return (card.tag == DeckCardTagType.Commander);
    }
}